module.exports = __webpack_public_path__ + "static/media/fulcrum.ccf013ce.svg";